import { EntityName } from 'record-it-time-common/EntityName';
import { DateUtils } from 'record-it-utils/utils/DateUtils/DateUtils';
import { WorkTimeEntry } from '../../../classes/entities/WorkTimeEntry/workTimeEntryTypes';
import { useEntityDeleteHandler } from './useEntityDeleteHandler';
export function useWorkTimeEntryDeleteHandler(workTimeEntry) {
  return useEntityDeleteHandler(EntityName.WorkTimeEntry, workTimeEntry, _temp);
}
function _temp(wte) {
  return DateUtils.withCurrentTimezone().formatDateRange(wte.startDate, wte.endDate);
}